<template>
    <header-search class="header-search--outlined-pill" InputTag="u-text-field-outlined-pill">
        <slot />
    </header-search>
</template>

<script>
import HeaderSearch from "@/components/publish/styles/headers/header-search.vue";

export default {
    props: {},
    components: {
        HeaderSearch,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
